import { Button } from "@/components/ui/button";
import { useCart } from "@/contexts/CartContext";
import { ShoppingCart } from "lucide-react";
import { useState } from "react";
import { CartModal } from "./CartModal";

export function CartButton() {
	const [isCartOpen, setIsCartOpen] = useState(false);
	const { itemCount } = useCart();

	return (
		<>
			<Button
				variant="ghost"
				size="icon"
				className="relative"
				onClick={() => setIsCartOpen(true)}>
				<ShoppingCart className="h-5 w-5" />
				{itemCount > 0 && (
					<span className="absolute -top-1 -right-1 h-5 w-5 text-xs flex items-center justify-center bg-accent text-white rounded-full">
						{itemCount}
					</span>
				)}
			</Button>

			<CartModal open={isCartOpen} onOpenChange={setIsCartOpen} />
		</>
	);
}
